import privacy from '../commonAssets/beemPrivacyText';
import deleteAccountText from '../commonAssets/deleteAccountText';
import terms from '../commonAssets/termsText';
import chatLogo from './assets/chat_logo.svg';
import favicon from './assets/favicon.svg';
import imprint from './assets/imprintText';
import opIcon from './assets/itg-op-icon.svg';
import logo from './assets/logo.svg';
import simpleLogo from './assets/simple_logo.svg';

const config = {
  title: 'ITG BEEM',
  description:
    'BEEM: Die rechtssichere App für schnelle und einfache Kommunikation zwischen Kunden und ITG-Ansprechpartner. Ganz unkompliziert.',
  identifier: 'itg',
  appName: 'ITG',
  defaultBrand: 'ITG',
  url: 'itgbeem.de',
  apiBaseUrl: 'https://api.itgbeem.de',
  helpUrl: 'https://hilfe.getbeem.de/',
  iosStoreUrl: 'https://apps.apple.com/us/app/itg-beem/id1612674816',
  androidStoreUrl: 'https://play.google.com/store/apps/details?id=de.itgbeem',
  supportEmail: 'support@getbeem.de',
  favicon,
  logo,
  chatLogo,
  simpleLogo,
  packageId: 'de.itgbeem',
  privacyText: privacy,
  termsText: terms,
  usercentricsId: 'NjwzimPc1',
  imprintText: imprint,
  deleteAccountText,
  welcomeText: 'Willkommen bei ITG BEEM!',
  identifierPlaceholder: 'Mobilnummer oder E-Mail Adresse',
  mainText: 'Bitte geben Sie Ihre Mobilnummer oder E-Mail Adresse ein, um sich anzumelden.',
  opIcon,
};

export default config;
